export default {
  props: {
    title: {
      type: String,
      required: false
    },
    currentCurrency: {
      type: String,
      required: false,
      default: () => { return 'USD' }
    },
    data: {
      type: Array,
      required: false,
      default: () => { return [] }
    },
    resumePerPax: {
    },
    resume: {
      type: Object,
      required: false
    },
    objectKey: {
      type: String
    },
    translateStringKey: {
      type: String
    },
    passengerQty: {
      type: Number,
      required: false,
      default: 1
    },
    separator: {
      type: String,
      required: false,
      default: '_'
    }
  },
  methods: {
    formatNumberToLocale (importe) {
      const numberFormat1 = new Intl.NumberFormat()
      return (numberFormat1.format(importe))
    }
  }
}
